<div class="completed-banner" [class]="variant">
    <div class="banner-icon">
        <mat-icon class="icon_large" [fontIcon]="icon"></mat-icon>
    </div>
    <span>{{message}}</span>
</div>